export default __webpack_public_path__ + "static/media/icon_checkmark.e0e9de2e.svg";